var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 10.3c0 1.9 1.5 3.4 3.4 3.4v30.9C3.4 46.5 5 48 6.9 48h34.3c1.9 0 3.4-1.5 3.4-3.4V13.7c1.9 0 3.4-1.5 3.4-3.4V3.4C48 1.5 46.5 0 44.6 0H3.4C1.5 0 0 1.5 0 3.4zm40.9 3v29.6H7.1V13.3zm3-7.2v4.1H4.1V6.1zM14.3 27.6h20.4v-4.1H14.3z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA0OCA0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0ibTAgMTEuM2MwIDEuOSAxLjUgMy40IDMuNCAzLjR2MzAuOWMwIDEuOSAxLjYgMy40IDMuNSAzLjRoMzQuM2MxLjkgMCAzLjQtMS41IDMuNC0zLjR2LTMwLjljMS45IDAgMy40LTEuNSAzLjQtMy40di02LjljMC0xLjktMS41LTMuNC0zLjQtMy40aC00MS4yYy0xLjkgMC0zLjQgMS41LTMuNCAzLjR6bTQwLjkgM3YyOS42aC0zMy44di0yOS42em0zLTcuMnY0LjFoLTM5Ljh2LTQuMXptLTI5LjYgMjEuNWgyMC40di00LjFoLTIwLjR6IiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMSkiLz48L3N2Zz4K";
export { SvgFiles as ReactComponent };